const placewithPageContainer = document.querySelector('.js-placewith-container');

//inteviewページ内でのみ呼び出し
if(placewithPageContainer){
  interviewPageFunctions();
}

function interviewPageFunctions(){
  isSpMode = false;
  placewithPageContainer.classList.add('is-initialized');

  observeResponsive();
  initImageSliders();
  initScrollyVideo();
  initScrollAnimation();
  changeMvImageOnScroll();
  changeScaleHeaderLogoOnScroll();
  playSplashAnimation();
  showAboveElements();
  alignBoxHeight();
  applyCalcTopPositionForStickyElement();
  initSmoothScroll();
  playVideoOnScroll();

  /**
   * SPかどうか判定
   */
  function observeResponsive (){
    const responsiveElement = placewithPageContainer.getElementsByClassName('js-placewith-responsive')[0];
    if(!responsiveElement) return;

    prevIsSpMode = 'pc';

    const observe = () => {
      const isSp = document.defaultView.getComputedStyle(responsiveElement, null).display === 'block';
      isSpMode = isSp;

      //デバイス切替時に発火するカスタムイベントを作成
      if (prevIsSpMode != isSp) {
        window.dispatchEvent(
          new Event('changeUserDevice', {
            'bubbles':true, 'cancelable':false
          })
        );
      }

      prevIsSpMode = isSp;
    }

    observe();
    window.addEventListener('resize', ()=> {
      observe();
    });
  }

  /**
   * スクロールでMV画像を切り替える
   */
  function changeMvImageOnScroll(){
    const items = [].slice.call(placewithPageContainer.querySelectorAll('.js-placewith-mv-item'));
    const itemLength = items.length;

    const mv = placewithPageContainer.querySelector('.js-placewith-mv');

    if(itemLength <= 1 || !mv) return;

    const firstItem = items[0];
    const secondItem = items[1];
    const pcBuffer = 400;
    const spBuffer = 380;

    const change = ()=>{
      if(isSpMode){
        //SP
        const mvPosition = mv.getBoundingClientRect().top;
        if(mvPosition < 0){
          if(-mvPosition >= spBuffer){
            firstItem.classList.add('is-hidden');
            secondItem.classList.add('is-active');
          }else{
            firstItem.classList.remove('is-hidden');
            secondItem.classList.remove('is-active');
          }
        }
      }else{
        //PC
        if(window.scrollY >= pcBuffer){
          firstItem.classList.add('is-hidden');
          secondItem.classList.add('is-active');
        }else{
          firstItem.classList.remove('is-hidden');
          secondItem.classList.remove('is-active');
        }
      }
    }

    window.addEventListener('scroll', ()=>{
      change();
    });
  }

  /**
   * MVが隠れるタイミングでヘッダーロゴのサイズを変更する
   * SPの場合は固定ヘッダーロゴを表示する
   * Productセクションではヘッダーは非表示にする
   */
  function changeScaleHeaderLogoOnScroll(){
    const mainContent = placewithPageContainer.querySelector('.js-placewith-content');
    const headerPc = placewithPageContainer.querySelector('.js-placewith-header-pc');
    const headerSp = placewithPageContainer.querySelector('.js-placewith-header-sp');
    const productSection = placewithPageContainer.querySelector('.js-placewith-product');
    const othersSection = placewithPageContainer.querySelector('.js-placewith-others');

    if(!mainContent || !headerPc || !headerSp) return;

    const change = ()=>{
      if(mainContent.getBoundingClientRect().top < 100){
        headerPc.classList.add('is-shrunk');
        headerSp.classList.add('is-visible');
      }else{
        headerPc.classList.remove('is-shrunk');
        headerSp.classList.remove('is-visible');
      }
      
      if(productSection){
        if(productSection.getBoundingClientRect().top < 100){
          headerPc.classList.add('is-hidden');
          headerSp.classList.add('is-hidden');
        }else{
          headerPc.classList.remove('is-hidden');
          headerSp.classList.remove('is-hidden');
        }
      }else if(othersSection){
        if(othersSection.getBoundingClientRect().top < 100){
          headerPc.classList.add('is-hidden');
          headerSp.classList.add('is-hidden');
        }else{
          headerPc.classList.remove('is-hidden');
          headerSp.classList.remove('is-hidden');
        }
      }

    }
    window.addEventListener('scroll', ()=>{
      change();
    });
  }

  /**
   * sticky要素のtopポジションが天地中央になるように計算
   */
  function applyCalcTopPositionForStickyElement(){
    const stickyElements = [].slice.call(placewithPageContainer.querySelectorAll('.js-placewith-sticky'));
    if(stickyElements.length < 1) return;

    const minTopMargin = 41;
    const headerHeight = 60;

    stickyElements.forEach((stickyElement)=>{
      let topPosition;
      
      const calcPosition = () => {
        if(document.body.classList.contains('announcement-Banner-hidden')){
          topPosition = (window.innerHeight * 0.5) - (stickyElement.clientHeight * 0.5);
          if (topPosition < minTopMargin){
            topPosition = minTopMargin;
          }
        }else{
          topPosition = (window.innerHeight * 0.5) - (stickyElement.clientHeight * 0.5) + (headerHeight * 0.5);
          if (topPosition < (minTopMargin + headerHeight)){
            topPosition = minTopMargin + headerHeight;
          }
        }

      }

      const applyStyle = () => {
        // stickyElement.style.top = 'calc(' + topPosition + 'px + var(--sticky-top-buffer))';
        stickyElement.style.top = topPosition + 'px';
      }

      const reset = () => {
        stickyElement.style.top = '';
      }

      const init = () => {
        if(isSpMode){
          reset();
        }else{
          calcPosition();
          applyStyle();
        }
      }

      init();

      window.addEventListener('load', init)
      window.addEventListener('scroll', init)
      window.addEventListener('resize', init)
      window.addEventListener('changeUserDevice', init)
      window.addEventListener('endSplashAnimation', init)
    })
  }

  /**
   * 画像やボックスの高さを揃える
   */
  function alignBoxHeight(){
    const baseElements = [].slice.call(placewithPageContainer.querySelectorAll('.js-placewith-align'));
    if(baseElements.length < 1) return;

    baseElements.forEach((baseElement)=>{
      const targetElement = baseElement.parentNode.parentNode.querySelector('.js-placewith-align-target')
      if(!targetElement) return;
  
      const apply = () => {
        targetElement.style.height = baseElement.clientHeight + 'px';
      };
      const reset = () => {
        targetElement.style.top = '';
      }

      const init = () => {
        if(isSpMode){
          reset();
        }else{
          apply();
        }
      }

      init();

      window.addEventListener('load', init)
      window.addEventListener('resize', init)
      window.addEventListener('scroll', init)
      window.addEventListener('changeUserDevice', init)
    });
  }

  /**
   * 画像カルーセル
   */
  function initImageSliders(){
    const sliderElements = [].slice.call(placewithPageContainer.querySelectorAll('.js-placewith-image-slider'));
    if(sliderElements.length < 1) return;

    sliderElements.forEach((sliderElement)=>{
      const slider = new Swiper(sliderElement, {
        speed: 1000,
        loop: true,
        effect: 'fade',
        crossFade: true,
        autoplay: {
          delay: 3000
        }
      });
      
      slider.autoplay.pause();

      //スライダーが画面内に表示されてから自動再生を開始する
      const sliderObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const target = entry.target;
          if (entry.isIntersecting) {
            if (! slider.autoplay.paused) {
              slider.autoplay.start();
            }
          }
        });
      }, {
        root: null,
        rootMargin: '-30% 0px -10% 0px'
      });
  
      sliderObserver.observe(sliderElement);
    });
  }

  /**
   * 動画スクロール連動
   */
  function initScrollyVideo(){
    const videoContainer = placewithPageContainer.querySelector('#placewithScrollVideoContainer');
    if(!videoContainer) return;

    const videoUrlPc = videoContainer.dataset.videoUrl;
    const videoUrlSp = videoContainer.dataset.videoUrlSp;

    let videoUrl = videoUrlPc;
    if(window.isSpMode && videoUrlSp){
      videoUrl = videoUrlSp;
    }

    const video = new ScrollyVideo({
      scrollyVideoContainer: "placewithScrollVideoContainer",
      src: videoUrl,
      frameThreshold: 0.05,
    });

    window.addEventListener('load', ()=>{
      video.currentTime = 1;
    });
  }

  /**
   * スクロールアニメーション
   */
  function initScrollAnimation() {
    const animationElements = [].slice.call(placewithPageContainer.querySelectorAll('.js-placewith-animation-scroll'));
    if(animationElements.length < 1) return;

    const animationObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const target = entry.target;

        if (entry.isIntersecting) {
          if (! target.classList.contains('is-visible')) {
            target.classList.add('is-visible');
          }
        }
      });
    }, {
      root: null,
      rootMargin: '-30% 0px -10% 0px'
    });

    animationElements.forEach((element) => {
      animationObserver.observe(element);
    });
  }

  /**
   * ページロード時に現在位置より上にある要素のアニメーションを完了させる
   */
  function showAboveElements() {
    const animationElements = [].slice.call(placewithPageContainer.querySelectorAll('.js-placewith-animation-scroll'));
    if(animationElements.length < 1) return;

    animationElements.forEach((element) => {
      const positionY = element.getBoundingClientRect().top;
      const animationTranslateValue = 0;

      if(positionY < window.innerHeight + animationTranslateValue){
        element.classList.add('is-visible');
      }
    });
  }

  /**
   * スプラッシュアニメーション再生
   */
  function playSplashAnimation(){
    const splashElement = placewithPageContainer.querySelector('.js-placewith-splash');
    const headerPc = placewithPageContainer.querySelector('.js-placewith-header-pc');
    const headerSp = placewithPageContainer.querySelector('.js-placewith-header-sp');
    let isPlayed = false;

    if(! splashElement || !headerPc || !headerSp) return;

    if(location.search.indexOf('debug') > -1){
      splashElement.classList.add('is-playing-splash');
      headerPc.classList.add('is-playing-splash');
      headerSp.classList.add('is-playing-splash');
      splashElement.classList.add('is-ended-splash');
      headerPc.classList.add('is-ended-splash');
      headerSp.classList.add('is-ended-splash');
      document.body.classList.add('is-ended-splash');
      headerPc.classList.add('is-bottom-layer');
      window.dispatchEvent(
        new Event('endSplashAnimation', {
          'bubbles':true, 'cancelable':false
        })
      );
    }

    const play = () => {
      if(isPlayed) return;
      isPlayed = true;

      splashElement.classList.add('is-playing-splash');
      headerPc.classList.add('is-playing-splash');
      headerSp.classList.add('is-playing-splash');

      setTimeout(()=>{
        splashElement.classList.add('is-ended-splash');
        headerPc.classList.add('is-ended-splash');
        headerSp.classList.add('is-ended-splash');
        document.body.classList.add('is-ended-splash');
        window.dispatchEvent(
          new Event('endSplashAnimation', {
            'bubbles':true, 'cancelable':false
          })
        );
      }, 1600);

      setTimeout(()=>{
        headerPc.classList.add('is-bottom-layer');
      }, 4000);
    }

    window.addEventListener('load', ()=>{
      play();
    })

    //fallback
    setTimeout(()=>{
      play();
    }, 1000)
  }

  /**
   * スムーズスクロール
   */
  function initSmoothScroll(){
    var scroll = new SmoothScroll('.pg-Placewith a[href*="#"]',{  
      speed: 1000,
      speedAsDuration: true
    });
  }

  /**
   * 通常動画 表示領域に近づいてから自動再生
   */
  function playVideoOnScroll(){
    const video = placewithPageContainer.querySelector('.js-placewith-normal-video');
    const trigger = placewithPageContainer.querySelector('.js-placewith-normal-video-autoplay-trigger');
    if(!video || !trigger) return;

    const triggerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          video.play();
        }else{
          video.pause();
        }
      });
    }, {
      root: null,
      rootMargin: '30% 0px 30% 0px',
    });

    triggerObserver.observe(trigger);
  }
}
